import { useFeeStore } from '@/store/useFeeStore';
import { useAuthStore } from '@/store/authStore';
import { useEffect } from 'react';

/**
 * Hook that provides access to the fixed fee amount.
 * This hook should be used in components that need to display or validate prices.
 * It automatically loads fees if the user is authenticated and fees haven't been loaded.
 */
export function useFixedFeeAmount() {
  const {
    fixedFeeAmount,
    isLoading,
    error,
    hasError,
    fetchFixedFeeAmount,
    isInitialized,
  } = useFeeStore();
  const { isAuthenticated } = useAuthStore();

  // Auto-load fees if user is authenticated and fees haven't been loaded
  useEffect(() => {
    if (isAuthenticated() && !isInitialized && !isLoading) {
      fetchFixedFeeAmount();
    }
  }, [isAuthenticated, isInitialized, isLoading, fetchFixedFeeAmount]);

  return {
    fixedFeeAmount,
    isLoading,
    error,
    hasError,
    fetchFixedFeeAmount,
  };
}
